import { useEffect, useRef, useState } from "react";
import classNames from "classnames";
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import auth from "../utils/firebaseClient";
import { useAuth } from "../utils/authContext";
import { getUserCredits } from "../utils/userData";
import { supabase } from "../utils/supabaseClient";
import MicRecorder from "mic-recorder-to-mp3";
import { PayPalButtons } from "@paypal/react-paypal-js";
import Sidebar from "../components/Sidebar";
import { GeneralModal } from "../components/GeneralModal";
import { MusicPlayer } from "../components/MusicPlayer";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function Home() {
  const [arianaAudio, setArianaAudio] = useState(null);
  const [drakeAudio, setDrakeAudio] = useState(null);
  const [kanyeAudio, setKanyeAudio] = useState(null);
  const [isArianaPlaying, setIsArianaPlaying] = useState(false);
  const [isDrakePlaying, setIsDrakePlaying] = useState(false);
  const [isKanyePlaying, setIsKanyePlaying] = useState(false);
  const [credits, setCredits] = useState(0);
  const [uploadedFile, setUploadedFile] = useState(null);
  const [youtubeLink, setYoutubeLink] = useState(null);

  //purchasing credits
  const [purchaseCredits, setPurchaseCredits] = useState(20);
  const [amount, setAmount] = useState(10);

  const [isOpen, setIsOpen] = useState(false); //sign in modal
  const [isModalOpen, setIsModalOpen] = useState(false); //general modal
  const [audioBlobURL, setAudioBlobURL] = useState(null);
  const [isBankrupt, setIsBankrupt] = useState(false);

  const [prediction, setPrediction] = useState(null);
  const handleRecorded = (recordedBlobURL) => {
    setUploadedFile(null); //recording is triggered, so clear the uploaded file
    setYoutubeLink(null); //recording is triggered, so clear the youtube link
    setAudioBlobURL(recordedBlobURL);
    // console.log("recordedBlobURL is", recordedBlobURL);
  };

  //TERRIBLE CODE FOR PAYPAL TO WORK (OTHERWISE IT DOESNT RERENDER WHEN AMOUNT CHANGES)
  const [renderKey, setRenderKey] = useState(0);

  const forceUpdate = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  useEffect(() => {
    // console.log("amount is now", amount, "so force updating")
    forceUpdate();
  }, [amount]);

  const uploadData = async (type, data) => {
    setIsModalOpen(true);
    return;
    // send the audio data url to the server
    console.log("SENDING AUDIO TO SERVER");
    const response = await fetch("/api/sendAudio", {
      method: "POST",
      body: JSON.stringify({ //audioDataURL or youtube link
        audioDataSentFromClient: data, 
        type: type,
      }),
      headers: {
        "user-id": user.uid,
        "Content-Type": "application/json",
        "artist-name": selectedArtist.codename,
      },
    });

    const responseJSON = await response.json();

    // if error
    if (responseJSON.error) {
      console.log("error is", responseJSON.error);
      setPrediction(responseJSON);
      return;
    }

    setPrediction(responseJSON);
    setCredits(responseJSON.credits);
  };

  
  const getAudioDuration = async (blob) => {
    return;
    return new Promise((resolve) => {
      const audio = new Audio(URL.createObjectURL(blob));
      audio.onloadedmetadata = () => resolve(audio.duration);
    });
  };

  
  const getDataURLFromBlob = async (blob) => {
    return;
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.readAsDataURL(blob);
    });
  };

  const fetchDataAndConvertToDataURL = async (audioBlobURL) => {
    return;
    const responseBlob = await fetch(audioBlobURL);
    const audioBlob = await responseBlob.blob();
    const audioDataURL = await getDataURLFromBlob(audioBlob);
    return audioDataURL;
  };

  
  async function audioToBase64(audioFile) {
    return;

    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onerror = reject;
      reader.onload = (e) => resolve(e.target.result);
      reader.readAsDataURL(audioFile);
    });
  }

  const handleGoClick = async () => {
    // alert("this button wont do anything")
    console.log("this button won't do anything")
    return;

    // Check if no audio source is selected
    if (!audioBlobURL && !uploadedFile && !youtubeLink) {
      alert("Please choose an audio file");
      console.log(
        "Doing nothing since audioBlobURL, uploadedFile, and youtubeLink are all null"
      );
      return;
    }
  
    // Check if multiple audio sources are selected
    if ((audioBlobURL && uploadedFile) || (audioBlobURL && youtubeLink) || (uploadedFile && youtubeLink)) {
      alert("Please select only one audio source: record, upload, or YouTube link.");
      console.log("Doing nothing since multiple audio sources are selected");
      return;
    }
  
    let audioDataURL; // this is the data url that will be sent to the server
  
    // If youtubeLink is not null
    if (youtubeLink) {
      console.log("youtube link is", youtubeLink)
      uploadData("youtube", youtubeLink);
      return;
    }
  
    // If audioBlobURL is not null
    if (audioBlobURL) {
      const responseBlob = await fetch(audioBlobURL);
      const audioBlob = await responseBlob.blob();
  
      const duration = await getAudioDuration(audioBlob);
      if (duration > 60) {
        alert("Please upload an audio file that is less than 1 minute long.");
        return;
      }
      // Get blob size in bytes
      const blobSize = audioBlob.size;
  
      console.log("Getting audioDataURL from audioBlobURL");
      audioDataURL = await fetchDataAndConvertToDataURL(audioBlobURL);
    }
  
    // If uploadedFile is not null
    if (uploadedFile) {
      // Convert the uploaded file to a data url
      console.log("Getting audioDataURL from uploadedFile");
      const duration = await getAudioDuration(uploadedFile);
      if (duration > 60) {
        alert("Please upload an audio file that is less than 1 minute long.");
        return;
      }
      audioDataURL = await audioToBase64(uploadedFile);
    }
  
    uploadData("audio", audioDataURL);
  };

  const { user, loading } = useAuth();

  useEffect(() => {
    // setIsBankrupt(true);

    // console.log("faking sending audio to server");
    // setTimeout(async () => {
    //   const response = {
    //     result:
    //       "https://replicate.delivery/pbxt/xDJcB9J5DcZmIdeQgLLUwwzswm6csmePbfNACF2Ne7eAkOYGC/tmpr6_lh808de_synthesized.wav",
    //   };
    //   console;
    //   setPrediction(response);
    // }, 2000);
    setArianaAudio(new Audio("/ariana.mp3"));
    setDrakeAudio(new Audio("/obama.mp3"));
    setKanyeAudio(new Audio("/kanye.mp3"));
  }, []);

  useEffect(() => {
    async function fetchCredits() {
      if (user) {
        const userCredits = await getUserCredits(user.uid);
        // console.log("user credits", userCredits);
        setCredits(userCredits);
      }
    }
    fetchCredits();
  }, [user]);

  const artists = [
    { name: "Drake", codename: "drake01" },
    { name: "Kanye West", codename: "kanye01" },
    { name: "Obama", codename: "obama01" },
    { name: "The Weeknd", codename: "theweeknd01" },
    { name: "Ariana Grande", codename: "ariana01" },
    { name: "Doja Cat", codename: "doja01" },
    { name: "Kendrick Lamar", codename: "kendrick01" },
    // { name: "Taylor Swift", codename: "taylorswift01" },
    { name: "21 Savage", codename: "21savage01" },
    { name: "Travis Scott", codename: "travisscott01" },
    { name: "XXXTentacion", codename: "xxxtentacion01" },
    { name: "Eminem", codename: "eminem01" },
  ];

  const toggleMusic = (artist) => {
    if (artist === "ariana") {
      if (isArianaPlaying) {
        arianaAudio.pause();
        setIsArianaPlaying(false);
      } else {
        drakeAudio.pause();
        setIsDrakePlaying(false);
        kanyeAudio.pause();
        setIsKanyePlaying(false);
        arianaAudio.currentTime = 0;
        arianaAudio.play();
        setIsArianaPlaying(true);
      }
    } else if (artist === "drake") {
      if (isDrakePlaying) {
        drakeAudio.pause();
        setIsDrakePlaying(false);
      } else {
        arianaAudio.pause();
        setIsArianaPlaying(false);
        kanyeAudio.pause();
        setIsKanyePlaying(false);
        drakeAudio.currentTime = 0;
        drakeAudio.play();
        setIsDrakePlaying(true);
      }
    } else if (artist === "kanye") {
      if (isKanyePlaying) {
        kanyeAudio.pause();
        setIsKanyePlaying(false);
      } else {
        arianaAudio.pause();
        setIsArianaPlaying(false);
        drakeAudio.pause();
        setIsDrakePlaying(false);
        kanyeAudio.currentTime = 0;
        kanyeAudio.play();
        setIsKanyePlaying(true);
      }
    }
  };

  const [selectedArtist, setSelectedArtist] = useState(artists[0]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);
  const [isDefunctModalOpen, setIsDefunctModalOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  return (
    <main
      className="flex flex-col bg-[#4706FF] min-h-screen
    "
    >
      <div className="relative">
        <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        <div className="flex flex-row w-full">
          <div
            className=" overflow-hidden
      border-b-[1px] border-white w-full cursor-pointer
      "
          >
            <div
              className="whitespace-nowrap
          font-extrabold  marquee-horizontal text-[57px]
        "
            >
              {
                // loop over 10 times
                [...Array(50)].map((_, i) => {
                  return (
                    <span
                      key={i}
                      className="mx-2 stretch font-tnr  leading-tight tracking-tighter text-white "
                    >
                      SUPERDUB
                    </span>
                  );
                })
              }
            </div>
          </div>

          <SignInButton
            user={user}
            credits={credits}
            setIsBankrupt={setIsBankrupt}
            toggleSidebar={toggleSidebar}
            setIsAboutModalOpen={setIsAboutModalOpen}
          />
        </div>

        {/* HERO */}
        <div
          className={`w-full flex flex-row justify-center items-center border-b-[1px] border-white p-12 text-start sm:text-center`}
        >
          <div className="text-[56px] font-signifier text-white tracking-tighter leading-tight">
            Make your vocals sound like{"  "}
            <div className="words">
              {
                // map over artists
                artists.map((artist, i) => {
                  if (i > 8) {
                    return (
                      <span
                        key={i}
                        className={classNames(
                          "text-[56px] font-SF text-white tracking-tighter leading-tight"
                        )}
                      >
                        {" "}
                        {artists[1].name}
                      </span>
                    );
                  }
                  return (
                    <span
                      key={i}
                      className={classNames(
                        "text-[56px] font-SF text-white tracking-tighter leading-tight ",
                        {
                          hidden: artist.name !== selectedArtist,
                        }
                      )}
                    >
                      {" "}
                      {artist.name}
                    </span>
                  );
                })
              }
            </div>
          </div>
        </div>
        {/* Examples*/}
        <div className="flex flex-row justify-center items-center border-b-[1px] border-white font-SF">
          <h2>EXAMPLES</h2>
        </div>
        <div className="grid grid-rows-3 sm:grid-cols-3 sm:grid-rows-1 border-b-[1px] border-white font-SF">
          <div
            onClick={() => {
              toggleMusic("kanye");
            }}
            className={
              `border-b-[1px] sm:border-r-[1px]
        sm:border-b-[0px]
        border-white h-full flex flex-row justify-start items-center p-3 hover:bg-yellow-400 transition cursor-pointer group ` +
              // if drake is playing
              (isKanyePlaying ? "bg-yellow-400" : "")
            }
          >
            <div
              className=" relative m-3 w-28 group-hover:scale-110 transition group-hover:rotate-2 
          "
            >
              <div
                // empty yellow square for hover effect
                className="flex justify-center items-center w-full h-full absolute top-0 left-0 group-hover:opacity-100 transition duration-500  
          "
              >
                <div className="w-full h-full bg-yellow-400 transition absolute opacity-0 group-hover:opacity-70 transition duration-800"></div>
                <img
                  src="/ye.png"
                  alt="logo"
                  className="w-16 absolute z-10
              opacity-0 group-hover:opacity-100 transition duration-500
              "
                />
              </div>
              <img
                src="/viennaicon.jpg"
                alt="logo"
                className="w-full h-full  transition"
              />
            </div>

            <div className="flex flex-col w-full text-end">
              <h2 className="font-signifier lg:text-5xl text-4xl text-white tracking-tighter leading-tight group-hover:text-[#4706FF] transition">
                Vienna
              </h2>
              <h2 className="font-SF text-xl text-white tracking-tighter leading-tight">
                Kanye
              </h2>
            </div>
          </div>

          <div
            onClick={() => {
              // console.log("clicked");
              toggleMusic("drake");
            }}
            className={
              `border-b-[1px] sm:border-r-[1px]
        sm:border-b-[0px]
        border-white h-full flex flex-row justify-start items-center p-3 hover:bg-yellow-400 transition cursor-pointer group ` +
              // if drake is playing
              (isDrakePlaying ? "bg-yellow-400" : "")
            }
          >
            <div className=" relative m-3 w-28 group-hover:scale-110 transition group-hover:rotate-2">
              <div
                // empty yellow square for hover effect
                className="flex justify-center items-center w-full h-full absolute top-0 left-0 group-hover:opacity-100 transition duration-500
          "
              >
                <div className="w-full h-full bg-yellow-400 transition absolute opacity-0 group-hover:opacity-70 transition duration-800"></div>
                <img
                  src="/obamahead.png"
                  alt="logo"
                  className="w-24 absolute z-10
              opacity-0 group-hover:opacity-100 transition duration-500
              "
                />
              </div>
              <img
                src="/sinatra.jpg"
                alt="logo"
                className="w-full h-full  transition"
              />
            </div>
            <div className="flex flex-col w-full text-end">
              <h2 className="font-signifier md:text-5xl text-4xl text-white tracking-tighter leading-tight group-hover:text-[#4706FF] transition">
                Fly Me To The Moon
              </h2>
              <h2 className="font-SF text-xl text-white tracking-tighter leading-tight">
                President Obama
              </h2>
            </div>
          </div>

          <div
            onClick={() => {
              toggleMusic("ariana");
            }}
            className={
              `border-b-[1px] sm:border-r-[1px]
        sm:border-b-[0px]
        border-white h-full flex flex-row justify-start items-center p-3 hover:bg-yellow-400 transition cursor-pointer group ` +
              // if drake is playing
              (isArianaPlaying ? "bg-yellow-400" : "")
            }
          >
            <div className=" relative m-3 w-28 group-hover:scale-110 transition group-hover:rotate-2">
              <div
                // empty yellow square for hover effect
                className="flex justify-center items-center w-full h-full absolute top-0 left-0 group-hover:opacity-100 transition duration-500
          "
              >
                <div className="w-full h-full bg-yellow-400 transition absolute opacity-0 group-hover:opacity-70 transition duration-800"></div>
                <img
                  src="/ariana.png"
                  alt="logo"
                  className="w-24 absolute z-10
              opacity-0 group-hover:opacity-100 transition duration-500
              "
                />
              </div>
              <img
                src="/callmemaybe.png"
                alt="logo"
                className="w-full h-full  transition"
              />
            </div>
            <div className="flex flex-col w-full text-end">
              <h2 className="font-signifier md:text-5xl text-4xl text-white tracking-tighter leading-tight group-hover:text-[#4706FF] transition">
                Call Me Maybe
              </h2>
              <h2 className="font-SF text-xl text-white tracking-tighter leading-tight">
                Ariana Grande
              </h2>
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-center items-center border-b-[1px] border-white font-SF">
          <h2>MAKE YOUR OWN</h2>
        </div>
        <div
          className="grid sm:grid-cols-2 sm:grid-rows-1        border-b-[1px] border-white font-SF
      "
        >
          <div className="flex flex-col w-full  border-r-[1px] border-white">
            <h2
              className="border-b-[1px] border-white p-3
           text-4xl text-white tracking-tighter leading-tight
          flex flex-row justify-center items-center
          "
            >
              Step 1: Upload your vocals
            </h2>
            <div
              className="flex p-3 flex-col
          sm:flex-grow border-b-[1px] border-white
          "
            >
              {/* input box for youtube link */}
              <div className="flex flex-row justify-center items-center">
                <input
                  type="text"
                  className="w-full p-2 bg-[#3F52FF] border-[1px] border-dashed border-[3px] text-white
                  placeholder-white
                  "
                  placeholder="Youtube link"
                  value={youtubeLink}
                  onChange={(e) => {setYoutubeLink(e.target.value);
                  setAudioBlobURL(null);
                  setUploadedFile(null);
                  
                  }}
                />
              </div>
              
              <span className="font-SF text-2xl text-white tracking-tighter leading-tight text-center pl-2 my-2">
                or
              </span>
              <AudioRecorder onRecorded={handleRecorded}></AudioRecorder>
              <span className="font-SF text-2xl text-white tracking-tighter leading-tight text-center pl-2 my-2">
                or
              </span>
              <FileDropZone
                onUpload={(file) => {
                  setUploadedFile(file);
                  // remove recording since we have a file
                  setYoutubeLink(null);
                  setAudioBlobURL(null);
                }}
              />
              
            </div>
          </div>
          <div className="flex flex-col w-full  border-white ">
            <h2
              className="border-b-[1px] border-white p-3
           text-4xl text-white tracking-tighter leading-tight
          flex flex-row justify-center items-center
          "
            >
              Step 2: Pick an artist
            </h2>
            <div className="flex flex-col">
              <div
                className="grid grid-cols-2 lg:grid-cols-3 gap-4 p-4
          overflow-y-scroll sm:max-h-[200px] 
          "
                style={{ display: "grid", gridTemplateRows: "auto" }}
              >
                {/* loop over artists */}
                {artists.map((artist, i) => (
                  <div
                    key={i}
                    className=" cursor-pointer"
                    onClick={() => setSelectedArtist(artist)}
                  >
                    <div
                      className={
                        `boxy-shadow h-full ` +
                        (artist.name === selectedArtist.name
                          ? "bg-yellow-400"
                          : "bg-[#3F52FF]")
                      }
                    >
                      <h3
                        className="text-xl font-medium
                    flex flex-row justify-center items-center
                    "
                      >
                        {artist.name}
                      </h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="flex flex-col
          justify-center flex-grow w-full items-center   border-t-[1px] border-white 
          "
            >
              <h2
                className="
           text-4xl text-white tracking-tighter leading-tight
          flex flex-row justify-center items-center  border-b-[1px] border-white w-full  p-3
          "
              >
                Step 3: HIT THE BUTTON
              </h2>
              <div className="flex flex-row justify-center items-center flex-grow w-full h-full">
                <div
                  className=" flex w-full flex-row justify-center items-center flex-grow h-full text-center pr-3 text-black button"
                  role="button"
                  onClick={() => {
                    if (!user) {
                      setIsOpen(true);
                    } else {
                      handleGoClick();
                    }
                  }}
                >
                  <span
                    className="
                text-[114px] lg:text-[128px] tracking-tighter leading-tight overflow-hidden"
                  >
                    START
                  </span>
                </div>
              </div>
              <GeneralModal
                isModalOpen={isBankrupt}
                onModalClose={() => {
                  setPrediction(null);
                  setIsBankrupt(false);
                }}
                user={user}
              >
                <div
                  className="w-full h-full flex flex-col
                justify-center content-center items-center
                "
                >
                  <h2
                    className="text-4xl text-white tracking-tighter leading-tight
                  self-center

                  "
                  >
                    Purchase more credits
                  </h2>
                  <div className="mt-4 w-full">
                    <>
                      {/* <Slider
                      min={0}
                      max={100}
                      value={purchaseCredits}
                      onChange={(value)=>{
                        setPurchaseCredits(value);
                        setAmount( Math.round(Math.pow(1.2, value)));
                      }}
                    /> */}

                      {/* html slider */}
                      <input
                        type="range"
                        step={10}
                        min="20"
                        max="110"
                        className={
                          "w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
                        }
                        value={purchaseCredits}
                        onChange={(e) => {
                          setPurchaseCredits(e.target.value);
                          setAmount(Math.round(e.target.value / 2));
                        }}
                        id="myRange"
                      />
                    </>
                  </div>
                  <div className="mt-4 text-white flex flex-col justify-end align-items-end w-full">
                    <div className="flex flex-row p-4 bg-[#3F52FF] rounded-lg  justify-end gap-4">
                      <h2
                        className="self-center w-full
                    font-SF text-2xl text-white tracking-tighter leading-tight 
                      "
                      >
                        Credits
                      </h2>
                      <div
                        className="flex flex-row
                      justify-center items-center
                      "
                      >
                        <h2
                          className="
                        text-2xl text-white tracking-tighter leading-tight
                        "
                        >
                          {purchaseCredits}
                        </h2>
                        {/* coin image */}
                        <img src="/coin.png" className="w-[25px] h-[25px]" />
                      </div>
                    </div>
                    <span
                      className="
                    font-SF text-sm text-white opacity-70 text-center py-2
                    "
                    >
                      1 credit is worth 1 generation.<br></br>
                      You can purchase up to 110 credits at a time
                    </span>
                    <div className="flex flex-row rounded-lg justify-end  items-center gap-2">
                      <h2
                        className="
                    font-SF text-4xl text-white tracking-tighter leading-tight  
                  "
                      >
                        Total:{" "}
                      </h2>
                      <h2
                        className="
                    font-SF text-4xl  tracking-tighter leading-tight text-yellow-400
                    "
                      >
                        ${amount}{" "}
                      </h2>
                    </div>
                    {/* <div className="w-full boxy-shadow cursor-pointer bg-yellow-400 mt-4">
                      PURCHASE
                    </div> */}
                    {user && (
                      <PayPalButtons
                        key={renderKey}
                        userId={user.uid}
                        style={{
                          layout: "horizontal",
                        }}
                        createOrder={async (data, actions) => {
                          // console.log(user.uid)
                          // console.log(amount)
                          const response = await fetch("/api/paypal", {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              action: "create",
                              amount: amount,
                            }),
                          });

                          if (!response.ok) {
                            const error = await response.json();
                            console.error("Error in createOrder:", error);
                            throw new Error(error.error);
                          }

                          const result = await response.json();
                          return result.id;
                        }}
                        onApprove={async (data, actions) => {
                          const response = await fetch("/api/paypal", {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                              action: "capture",
                              orderID: data.orderID,
                              userId: user.uid,
                              amount: amount,
                            }),
                          });

                          if (!response.ok) {
                            const error = await response.json();
                            console.error("Error in onApprove:", error);
                            throw new Error(error.error);
                          }

                          const result = await response.json();

                          // console.log("FINISHED", result);

                          // reload the page
                          window.location.reload();
                        }}
                        onError={(err) => {
                          // Handle errors
                        }}
                      />
                    )}
                  </div>
                </div>
              </GeneralModal>
              <GeneralModal
                isModalOpen={isModalOpen}
                onModalClose={() => {
                  setPrediction(null);
                  setIsModalOpen(false);
                }}
              >
                {prediction?.error && !prediction?.audioFileURL ? (
                  <div className="w-full h-full flex flex-col justify-center  items-center">
                    <h2 className="text-2xl text-white tracking-tighter leading-tight">
                      {prediction.message}
                    </h2>
                  </div>
                ) : prediction === null ? (
                  <div className="w-full h-full flex flex-col justify-center  items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white w-[50px] h-[50px]"
                      fill="white"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z" />
                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z" />
                    </svg>
                    <h2 className="text-2xl text-white tracking-tighter leading-tight">
                      Generating...
                    </h2>
                    <span
                      className="
                 tracking-tighter leading-tight text-center
                    "
                    >
                      (do not close this window)
                    </span>
                    <span
                      className="
                 tracking-tight leading-tight mt-4 text-center text-white opacity-70
                    "
                    >
                      this process usually takes around 20-30 seconds but it
                      might take longer on your first run
                    </span>
                    <span
                      className="
                 tracking-tight leading-tight mt-4 text-center text-white opacity-100
                    "
                    >
                      you can access all your generations in the sidebar
                    </span>
                  </div>
                ) : (
                  <div className="w-full h-full flex flex-col justify-center items-center">
                    <MusicPlayer
                      audioSRC={prediction ? prediction.audioFileURL : null}
                    ></MusicPlayer>
                  </div>
                )}
              </GeneralModal>
              <SignInModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                user={user}
              ></SignInModal>
              <GeneralModal
                isModalOpen={isAboutModalOpen}
                onModalClose={() => {
                  setIsAboutModalOpen(false);
                }}
              >
                 <div
                  className="
          flex flex-col justify-center items-start w-full h-full font-SF text-white text-lg font-medium gap-4
          "
                >
                  <h1
                    className="
           stretch font-tnr  leading-tight tracking-tighter text-white text-3xl font-bold h-full mb-4
          "
                  >
                    About
                  </h1>
                  <span>
                    All content on{" "}
                    <span
                      className="
              stretch font-tnr  leading-tight tracking-tighter text-white text-lg  font-bold h-full"
                    >
                      SUPERDUB
                    </span>{" "}
                    is synthetically generated by AI for entertainment purposes.
                    None of the generated content represents the views of either
                    the creator or the artists themselves.
                  </span>
                  <span>
                    If you feel strongly about any of the AI models on this
                    website,{" "}
                    <a
                      href="https://twitter.com/gd3kr"
                      target="_blank"
                      className="underline"
                    >
                      contact me on twitter
                    </a>
                  </span>
                  <div
                    className="flex flex-col self-center cursor-pointer
            "
                    onClick={() => {
                      window.open("https://twitter.com/gd3kr", "_blank");
                    }}
                  >
                    <span className="mt-4 stretch font-tnr  leading-tight tracking-tighter text-blue-400 text-3xl self-center  font-bold h-full">
                      created by aarya*
                    </span>
                    <span className="font-SF text-blue-400 text-sm self-center">
                      <b>*</b>Cybernetically enhanced by{" "}
                      <span className="stretch font-tnr  leading-tight tracking-tighter text-blue-400 font-bold">
                        GPT-4
                      </span>
                    </span>
                  </div>
                  </div>
              </GeneralModal>

              <GeneralModal
                isModalOpen={isDefunctModalOpen}
                onModalClose={() => {
                  setIsDefunctModalOpen(false);
                }}
              >

<div
                  className="
          flex flex-col justify-center items-start w-full h-full font-SF text-white text-lg font-medium gap-4
          "
                >
                  <h1
                    className="
           stretch font-tnr  leading-tight tracking-tighter text-white text-3xl font-bold h-full mb-4
          "
                  >
                    From The Creator
                  </h1>
                  <span>
                    <span 
                      className="
              stretch font-tnr  leading-tight tracking-tighter text-white text-lg  font-bold h-full"
                    >
                      SUPERDUB
                    </span>{" "}
                   is unfortunately no longer operational, this webpage only serves as a hollow reminder of its fleeting (but fun) existence. 
                   </span>

                   <span>I was forced to shut down Superdub in compliance with a request from Universal Media Group three days after its launch, where non-compliance would involve legal action. I decided that it wasn{"'"}t worth my time, and that was the end of that. 
                  </span>

                  <span>
                    While the AI{"'"}s defunct, I{"'"}m still gonna keep the frontend up. So feel free to click around and experience my carefully crafted JavaScript micro-interactions. If you{"'"}d like to listen to more examples of what this website was capable of, {" "}
                    <a className="text-bold font-bold" href="https://x.com/gd3kr/status/1649835078716129280?s=20" target="_blank" rel="noopener noreferrer">here{"'"}s the twitter thread</a>
                  </span>

                  <span>
                    If you liked this project, you{"'"}d probably enjoy my  <a className="text-bold font-bold" href="https://x.com/gd3kr/" target="_blank" rel="noopener noreferrer">Twitter</a>, where I keep posting things I{"'"}m working on. 
                  </span>
                    
                </div>
              </GeneralModal>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

const SignInButton = ({
  user,
  credits,
  setIsBankrupt,
  toggleSidebar,
  setIsAboutModalOpen,
}) => {
  const handleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // console.log("User:", user);
    } catch (error) {
      console.error("Error signing in:", error.message);
    }
  };
  if (!user) {
    return (
      <div
        className="
        w-[90%] md:w-[25%]
        border-b-[1px] border-white
        border-l-[1px] border-white
        flex flex-row justify-start items-center
       
        "
      >
        <div
          className="flex flex-col px-6 h-full
justify-center items-center hover:bg-green-400 transition-all duration-300 ease-in-out cursor-pointer border-white border-r
"
          onClick={() => {
            setIsAboutModalOpen(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M5.933.87a2.89 2.89 0 0 1 4.134 0l.622.638.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636zM7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm1.602-2.027c.04-.534.198-.815.846-1.26.674-.475 1.05-1.09 1.05-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745.336 0 .504-.24.554-.627z" />
          </svg>
        </div>
        <span
          onClick={handleSignIn}
          className="
          
        font-SF text-4xl lg:text-6xl group-hover:text-black text-center w-full  cursor-pointer hover:bg-yellow-400 transition duration-300 ease-in-out h-full flex flex-row justify-center items-center
      "
        >
          SIGN IN
        </span>
      </div>
    );
  }
  return (
    <div
      className="
      w-[90%] md:w-[25%]

        border-b-[1px] border-white
        border-l-[1px] border-white
        flex flex-row justify-center items-center
        "
    >
      <div
        className="flex flex-col w-full h-full 
      border-r-[1px] border-white  justify-center items-center "
      >
        <span
          className="text-white font-SF text-lg
      group-hover:text-black
      flex flex-row justify-center items-center  border-white w-full h-full  p-2 
      "
        >
          {user.displayName || <Skeleton />}
        </span>
        <div
          className="text-white font-SF text-lg
      group-hover:text-black
      flex flex-row justify-center items-center h-full p-2   hover:bg-yellow-400 w-full group transition cursor-pointer hidden
      "
          // onClick={() => {
          //   setIsBankrupt(true);
          // }}
        >
          <img src="./coin.png" className="w-[24px] h-[24px]" />

          <span className="text-blue-300 font-SF text-lg group-hover:text-black">
            {user ? credits : 0}
          </span>
        </div>
      </div>
      <div
        className="flex flex-col px-6 h-full
justify-center items-center hover:bg-green-400 transition-all duration-300 ease-in-out cursor-pointer border-white
"
        onClick={() => {
          setIsAboutModalOpen(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          fill="currentColor"
          viewBox="0 0 16 16"
        >
          <path d="M5.933.87a2.89 2.89 0 0 1 4.134 0l.622.638.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636zM7.002 11a1 1 0 1 0 2 0 1 1 0 0 0-2 0zm1.602-2.027c.04-.534.198-.815.846-1.26.674-.475 1.05-1.09 1.05-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.71 1.71 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745.336 0 .504-.24.554-.627z" />
        </svg>
      </div>
      <div
        className="flex flex-col px-6 h-full
justify-center items-center hover:bg-yellow-400 transition-all duration-300 ease-in-out cursor-pointer border-l-[1px] border-white
"
        onClick={toggleSidebar}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          className="bi bi-list"
          viewBox="0 0 16 16"
        >
          <path d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
        </svg>
      </div>
    </div>
  );
};

function FileDropZone({ onUpload }) {
  const [dragging, setDragging] = useState(false);
  const [file, setFile] = useState(null);
  const inputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    setFile(e.dataTransfer.files[0]);
    onUpload(e.dataTransfer.files[0]);
  };

  const handleRemove = () => {
    setFile(null);
    onUpload(null);
  };

  const handleInputChange = (e) => {
    setFile(e.target.files[0]);
    onUpload(e.target.files[0]);
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  return (
    <div
      className={`flex sm:flex-grow  p-3 flex-col justify-center bg-[#3F52FF] 
      border-dashed border-2 border-white
      ${dragging ? "border-2 border-gray-300" : ""}`}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      <input
        type="file"
        accept=".mp3,.wav"
        ref={inputRef}
        style={{ display: "none" }}
        onChange={handleInputChange}
      />
      <div className="flex justify-center items-center ml-3  flex-col">
        <h2 className="font-signifier text-2xl text-white tracking-tighter leading-tight text-center pr-3">
          {!file && "drag and drop an audio file"}
        </h2>
        <h2 className="text-[#d6d6d6]">{!file && "(mp3 and wav)"}</h2>
      </div>
      <div className="flex flex-row justify-center items-center">
        {file && (
          <span
            className="font-SF text-sm text-white text-center cursor-pointer boxy-shadow bg-yellow-400 absolute z-100"
            onClick={handleRemove}
          >
            &#x2715;
          </span>
        )}
        {file && (
          <span className="font-SF text-xl text-white tracking-tighter leading-tight text-center pl-2 my-2">
            {file.name}
          </span>
        )}
      </div>
    </div>
  );
}

const SignInModal = ({ isOpen, onClose, children, user }) => {
  const [visible, setVisible] = useState(isOpen);

  const handleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    onClose();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      // console.log("User:", user);
    } catch (error) {
      console.error("Error signing in:", error.message);
    }
  };

  useEffect(() => {
    setVisible(isOpen);
  }, [isOpen]);

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="absolute inset-0 bg-black opacity-50 z-10"
        onClick={onClose}
      ></div>
      <div className="z-20">
        <div
          className=" bg-[#4706FF] p-6 w-96 animate-popin
           border-[10px] border-black
          "
        >
          {" "}
          <div className="flex justify-between items-center mb-4">
            <div className="text-white  text-xl font-SF flex flex-col justify-content gap-2">
              <span> sign in first please</span>
              {/* <span
              className="
              text-[#d6d6d6]
              "
              >on the plus side it takes one click :)</span> */}
            </div>
            {/* sign in button */}
          </div>
          {/* <p>(it is one button click)</p> */}
          {/* <input
            className="w-full h-full p-2 text-black text-xl font-medium"
            type="text"
            placeholder="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></input> */}
          <div
            onClick={handleSignIn}
            className={`boxy-shadow h-full bg-yellow-400 cursor-pointer  mt-2`}
          >
            {/* input box */}
            <h3
              className="text-xl font-medium
            flex flex-row justify-center items-center
            "
            >
              SIGN IN
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

const AudioRecorder = ({ onRecorded }) => {
  const [Mp3Recorder, setMp3Recorder] = useState(
    new MicRecorder({ bitRate: 128 })
  );

  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState("");
  const [isBlocked, setIsBlocked] = useState(false);

  function getUserMedia(constraints) {
    const getUserMedia =
      navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia;
    if (!getUserMedia) {
      return Promise.reject(new Error("getUserMedia is not supported"));
    } else {
      return new Promise((resolve, reject) =>
        getUserMedia.call(navigator.mediaDevices, constraints, resolve, reject)
      );
    }
  }

  const handleButtonClick = () => {
    if (isRecording) {
      Mp3Recorder.stop()
        .getMp3()
        .then(([buffer, blob]) => {
          const blobURL = URL.createObjectURL(blob);
          setBlobURL(blobURL);
          onRecorded(blobURL);
          setIsRecording(false);
        })
        .catch((e) => console.log(e));
    } else {
      if (isBlocked) {
        console.log("Permission Denied");
      } else {
        Mp3Recorder.start()
          .then(() => {
            setIsRecording(true);
          })
          .catch((e) => console.error(e));
      }
    }
  };

  return (
    <>
      <div
        onClick={handleButtonClick}
        className="flex flex-row justify-center items-center"
      >
        <div
          className={
            `flex justify-center items-center   boxy-shadow cursor-pointer w-full  
    ` +
            (isRecording ? " animate-pulse  " : "") +
            (blobURL ? "bg-green-400  " : "bg-yellow-400")
          }
        >
          <h2
            className={`font-SF text-2xl text-black tracking-tighter leading-tight text-center pr-3 `}
          >
            {isRecording ? "Stop Recording" : "Start Recording"}
          </h2>
          <div
            className={
              `w-4 h-4 bg-red-500 rounded-full ` +
              (isRecording
                ? `animate-pulse  
      `
                : "animate-none ")
            }
          ></div>
          {/* indicator if voice has been recorded */}
        </div>
      </div>
    </>
  );
};
